import FormInputTypes from '../components/atoms/formEnums/formInputTypes';


export default {
  title: 'Environment',
  attributeName: 'environment',
  fields: [
    {
      attributeName: 'environmentScene',
      helpText: 'Default scene name.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Environment Scene',
      default: 'SportsRoom_Generic_01'
    },
    {
      attributeName: 'environmentFloorLogo',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Environmment Floor Logo - 1:1',
      helpText: 'Environmment Floor Logo',
      hasSelect:false,
      fileType: ['.png'],
      aspectRatio: '1:1',    
      
    },
    {
      attributeName: 'logoUI',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Logo UI - 880x256',
      allowedSizes:[
           { "width": 880, "height": 256 },
      ],
      errorResolution: 'Older Image Resolution',
      hasSelect:false,
      helpText: 'Each Room will have its own brand logo.',
      fileType: ['.png'],
    },
     {
      attributeName: 'logoUISquare',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Logo UI (Square)',
      hasSelect:false,
      helpText: 'This logo is used in calendar component under layouts.',
      fileType: ['.png'],
      aspectRatio: '1:1',    

    },
    {
      attributeName: 'skybox',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Skybox',
      hasSelect:false,
      helpText: 'This will be the resource for the skybox in the app.',
      fileType: ['.png'],
      // aspectRatio: '1:1',    
    },
    {
      attributeName: 'floorTextureAlbedo',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Floor Texture Albedo - 1:1',
      hasSelect:false,
      helpText: '3D Texture Color.',
      fileType: ['.png','.jpg'],
      aspectRatio: '1:1',
    },
    {
      attributeName: 'floorTextureNormal',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Floor Texture Normal - 1:1',
      hasSelect:false,
      helpText: '3D Texture',
      fileType: ['.png','.jpg'],
      aspectRatio: '1:1',
    },
    {
      attributeName: 'floorReflexions',
      helpText: 'Floor Reflexions.',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Floor Reflexions',
      placeholder: 'Floor Reflexions...',
    },
    {
      attributeName: 'floorColorTint',
      helpText: 'The color of the floor, it tints the texture.',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Floor Color Tint',
    },
    {
      attributeName: 'carpetColorTint',
      helpText: 'The color of the carpet, it tints the texture.',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Carpet Color Tint',
    },
    {
      attributeName: 'scrollingScreen',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Scrolling Screen 1024x256',
      hasSelect:false,
      helpText: 'Scrolling Screen',
      fileType: ['.jpg','.png'],
      allowedSizes: [
        { width: 1024, height: 256 }
      ],
    },
    {
      attributeName: 'environmentPoster1',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Environmment Poster 1 - 1:2',
      hasSelect:false,
      helpText: 'Environmment Poster 1',
      fileType: ['.jpg','.png'],
      aspectRatio: '1:2',
      
    },
    {
      attributeName: 'environmentPoster2',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Environmment Poster 2 - 1:2',
      hasSelect:false,
      helpText: 'Environmment Poster 2',
      fileType: ['.jpg','.png'],
      aspectRatio: '1:2',
      
    },
    {
      attributeName: 'environmentPoster3',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Environmment Poster 3 - 1:2',
      hasSelect:false,
      helpText: 'Environmment Poster 3',
      fileType: ['.jpg','.png'],
      aspectRatio: '1:2',
    },
    {
      attributeName: 'environmentPoster4',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Environmment Poster 4 - 1:2',
      hasSelect:false,
      helpText: 'Environmment Poster 4',
      fileType: ['.jpg','.png'],
      aspectRatio: '1:2',
    },
    {
      attributeName: 'environmentPoster5',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Environmment Poster 5 - 1:2',
      hasSelect:false,
      helpText: 'Environmment Poster 5',
      fileType: ['.jpg','.png'],
      aspectRatio: '1:2',
    },
    {
      attributeName: 'environmentPoster6',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Environmment Poster 6 - 1:2',
      hasSelect:false,
      helpText: 'Environmment Poster 6',
      fileType: ['.jpg','.png'],
      aspectRatio: '1:2',
    },
  ],
};
